/* eslint-disable react-hooks/exhaustive-deps */
// import { useState } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardBody } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
// import Loading from '@components/Shared/Loader/Loading';
// import useGetApInvoicesList from '@hooks/Finance/ApInvoices/useGetApInvoicesList';
// import NeatixModal from '@components/Modal/NeatixModal';
// import PurchaseRequestList from '../../../PUR/Transactions/PurchaseRequest/PurchaseRequestList';
// import NtxTable from '@components/DataTable/NtxTable';

// const Index = () => {
//   const [showPurchaseRequest, setShowPurchaseRequest] = useState(false);

//   const { t, i18n } = useTranslation();

//   const { ApInvoicesList: data, loading, error } = useGetApInvoicesList();

//   const getPostedFlagBadge = (flag: boolean) =>
//     flag ? (
//       <span className='badge bg-success'>
//         <i className='fas fa-check me-1'></i>
//         {t('Posted')}
//       </span>
//     ) : (
//       <span className='badge bg-danger'>
//         <i className='fas fa-times me-1'></i>
//         {t('NotPosted')}
//       </span>
//     );

//   const getInvoiceTypeBadge = (type: string) => {
//     switch (type) {
//       case 'Standard':
//         return (
//           <span className='badge bg-primary'>
//             <i className='fas fa-file-invoice me-1'></i>
//             {t('Standard')}
//           </span>
//         );
//       case 'CreditMemo':
//       case 'DebitMemo':
//         return (
//           <span className='badge bg-warning text-dark'>
//             <i className='fas fa-file-invoice-dollar me-1'></i>
//             {t('DebitMemo')}
//           </span>
//         );
//       default:
//         return (
//           <span className='badge bg-secondary'>
//             <i className='fas fa-file me-1'></i>
//             {type}
//           </span>
//         );
//     }
//   };

//   const getReferenceTypeBadge = (refType: string) => {
//     switch (refType) {
//       case 'Bill':
//         return (
//           <span className='badge bg-success text-dark'>
//             <i className='fas fa-shopping-cart me-1'></i>
//             {t('أمر شـــراء')}
//           </span>
//         );
//       case 'EXP':
//         return (
//           <span className='badge bg-dark'>
//             <i className='fas fa-receipt me-1'></i>
//             {t('مصروفات')}
//           </span>
//         );
//       case 'EXP_FAST':
//         return (
//           <span className='badge bg-dark'>
//             <i className='fas fa-receipt me-1'></i>
//             {t('مصروفات سريــعة')}
//           </span>
//         );
//       case 'DebitMemo':
//         return (
//           <span className='badge bg-warning text-dark'>
//             <i className='fas fa-file-invoice-dollar me-1'></i>
//             {t('مردود مشتريات')}
//           </span>
//         );
//       case 'Discount':
//         return (
//           <span className='badge bg-info'>
//             <i className='fas fa-percentage me-1'></i>
//             {t('خصم')}
//           </span>
//         );
//       default:
//         return (
//           <span className='badge bg-info text-dark'>
//             <i className='fas fa-keyboard me-1'></i>
//             {t('يدوي')}
//           </span>
//         );
//     }
//   };

//   const formatAmount = (amount: number) => {
//     return new Intl.NumberFormat(i18n.language, {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(amount);
//   };

//   const columns = [
//     { title: t('InvoiceNumber'), key: 'invoiceNum' },
//     { title: t('InvoiceDate'), key: 'invoiceDate' },
//     { title: t('Supplier'), key: 'peopleName' },
//     {
//       title: t('InvoiceType'),
//       key: 'invoiceType',
//       sortValue: (row: any) => row.invoiceType_sort
//     },
//     { title: t('المصدر'), key: 'referenceType', sortValue: (row: any) => row.referenceType_sort },
//     { title: t('وحدة التشغيـل'), key: 'organizationName' },
//     { title: t('Amount'), key: 'invoiceAmount' },
//     {
//       title: t('PostingStatus'),
//       key: 'postedFlag',
//       className: 'text-center',
//       sortValue: (row: any) => row.postedStatus
//     },
//     { title: '', key: 'action', className: 'text-end' }
//   ];

//   const tableData = data.map(item => ({
//     invoiceNum: item.invoiceNum,
//     invoiceDate: item.invoiceDate,
//     peopleName: i18n.language === 'en' ? item.peopleName : item.peopleName2,
//     invoiceType: getInvoiceTypeBadge(item.invoiceType),
//     referenceType: getReferenceTypeBadge(item.referenceType),
//     organizationName: i18n.language === 'en' ? item.organizationName : item.organizationName2,
//     // invoiceAmount: item.invoiceAmount,
//     invoiceAmount: <span className='fw-bold text-theme'>{formatAmount(item.invoiceAmount)}</span>,

//     postedFlag: getPostedFlagBadge(item.postedFlag || false),
//     //
//     postedStatus: item.postedFlag ? 1 : 0,
//     invoiceType_sort: item.postedFlag,
//     referenceType_sort: item.referenceType,
//     //
//     action: (
//       <Link to={`${item.id}/UpdateApInvoices`} className='btn btn-sm btn-outline-theme mx-1'>
//         <i className='fas fa-info-circle fa-lg'></i>
//       </Link>
//     ),
//     rowClass: undefined // احتياطي لو تحب تضيف شرط لاحق
//   }));

//   return (
//     <div>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={[
//             {
//               name: 'Home',
//               link: ':moduleHome'
//             },

//             {
//               name: 'PaymentInvoices',
//               link: null
//             }
//           ]}
//           PageName='PaymentInvoices'
//         />

//         <div className='ms-auto'>
//           <Link to='AddApInvoices' className='btn me-1 btn-theme'>
//             <i className='fa fa-plus-circle fa-fw me-1'></i>
//             {t('NewInvoice')}
//           </Link>
//         </div>
//       </div>
//       <Card>
//         <Loading loading={loading} error={error}>
//           <CardBody>
//             <NtxTable
//               data={tableData || []}
//               columns={columns}
//               dataPerPage={10}
//               theadClass=''
//               tableClass='table text-nowrap table-hover '
//               enableSearch={true}
//               showRecordsSelector
//             />
//           </CardBody>
//         </Loading>
//       </Card>

//       <NeatixModal
//         show={showPurchaseRequest}
//         setShow={setShowPurchaseRequest}
//         bodyClassName='p-0'
//         size='lg'
//         showHeader={false}
//       >
//         <PurchaseRequestList Route='ApInvoice' />
//       </NeatixModal>
//     </div>
//   );
// };

// export default Index;

// import { useEffect, useState } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
// import Loading from '@components/Shared/Loader/Loading';
// import NeatixModal from '@components/Modal/NeatixModal';
// import PurchaseRequestList from '../../../PUR/Transactions/PurchaseRequest/PurchaseRequestList';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { getPagedData, setEndpoint, setFixedFilters } from '@store/DynamicFilter/dynamicTableSlice';
// import { DynamicFilter } from '@Helper/DynamicFilter/DynamicFilter';
// import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';
// import { usePermissions } from '@Helper/Permisstions/usePermissions';
// import Select from 'react-select';
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';

// const TABLE_KEY = 'ApInvoices';

// const Index = () => {
//   const { OperatingUnitOptions } = useGetOperatingUnitWithPermission();
//   const { OptionSuppliers } = useGetSuppliersList();

//   const [showPurchaseRequest, setShowPurchaseRequest] = useState(false);
//   const [showFilters, setShowFilters] = useState(false);

//   // ✅ حالة الفلاتر الجديدة
//   const [supplierFilter, setSupplierFilter] = useState<any>(null);
//   const [organizationFilter, setOrganizationFilter] = useState<any>(null);
//   const [dateFrom, setDateFrom] = useState('');
//   const [dateTo, setDateTo] = useState('');

//   const [isUsingFixedFilters, setIsUsingFixedFilters] = useState(false);

//   const { t, i18n } = useTranslation();
//   const { HasPermission } = usePermissions();

//   const dispatch = useAppDispatch();
//   const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);
//   const data = tableState?.data ?? [];
//   const loading = tableState?.loading ?? false;
//   const error = tableState?.error ?? null;
//   const totalItems = tableState?.totalItems ?? 0;

//   useEffect(() => {
//     dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'Ap/GetApInvoicesList_Paged' }));

//     dispatch(
//       setFixedFilters({
//         tableKey: TABLE_KEY,
//         fixedFilters: {}
//       })
//     );

//     dispatch(getPagedData({ tableKey: TABLE_KEY }));
//   }, [dispatch]);

//   // ✅ دالة تطبيق الفلاتر
//   const applyFilters = () => {
//     const filters: Record<string, any> = {};

//     // ✅ فلترة حسب المورد
//     if (supplierFilter) {
//       filters['peopleId'] = supplierFilter.value;
//     }

//     // ✅ فلترة حسب وحدة التشغيل
//     if (organizationFilter) {
//       filters['organizationId'] = organizationFilter.value;
//     }

//     // ✅ فلترة حسب التاريخ من
//     if (dateFrom) {
//       filters['invoiceDateFrom'] = dateFrom;
//     }

//     // ✅ فلترة حسب التاريخ إلى
//     if (dateTo) {
//       filters['invoiceDateTo'] = dateTo;
//     }

//     dispatch(
//       setFixedFilters({
//         tableKey: TABLE_KEY,
//         fixedFilters: filters
//       })
//     );
//     setIsUsingFixedFilters(Object.keys(filters).length > 0);

//     dispatch(getPagedData({ tableKey: TABLE_KEY }));
//   };

//   // ✅ دالة مسح جميع الفلاتر
//   const clearFilters = (): void => {
//     setSupplierFilter(null);
//     setOrganizationFilter(null);
//     setDateFrom('');
//     setDateTo('');

//     dispatch(
//       setFixedFilters({
//         tableKey: TABLE_KEY,
//         fixedFilters: {}
//       })
//     );
//     setIsUsingFixedFilters(false);

//     dispatch(getPagedData({ tableKey: TABLE_KEY }));
//   };

//   const displayData = isUsingFixedFilters ? data : data;

//   const getPostedFlagBadge = (flag: boolean) =>
//     flag ? (
//       <span className='badge bg-success'>
//         <i className='fas fa-check me-1'></i>
//         {t('Posted')}
//       </span>
//     ) : (
//       <span className='badge bg-danger'>
//         <i className='fas fa-times me-1'></i>
//         {t('NotPosted')}
//       </span>
//     );

//   const getInvoiceTypeBadge = (type: string) => {
//     switch (type) {
//       case 'Standard':
//         return (
//           <span className='badge bg-primary'>
//             <i className='fas fa-file-invoice me-1'></i>
//             {t('Standard')}
//           </span>
//         );
//       case 'CreditMemo':
//       case 'DebitMemo':
//         return (
//           <span className='badge bg-warning text-dark'>
//             <i className='fas fa-file-invoice-dollar me-1'></i>
//             {t('DebitMemo')}
//           </span>
//         );
//       default:
//         return (
//           <span className='badge bg-secondary'>
//             <i className='fas fa-file me-1'></i>
//             {type}
//           </span>
//         );
//     }
//   };

//   const getReferenceTypeBadge = (refType: string) => {
//     switch (refType) {
//       case 'Bill':
//         return (
//           <span className='badge bg-success text-dark'>
//             <i className='fas fa-shopping-cart me-1'></i>
//             {t('أمر شـــراء')}
//           </span>
//         );
//       case 'EXP':
//         return (
//           <span className='badge bg-dark'>
//             <i className='fas fa-receipt me-1'></i>
//             {t('مصروفات')}
//           </span>
//         );
//       case 'EXP_FAST':
//         return (
//           <span className='badge bg-dark'>
//             <i className='fas fa-receipt me-1'></i>
//             {t('مصروفات سريــعة')}
//           </span>
//         );
//       case 'DebitMemo':
//         return (
//           <span className='badge bg-warning text-dark'>
//             <i className='fas fa-file-invoice-dollar me-1'></i>
//             {t('مردود مشتريات')}
//           </span>
//         );
//       case 'Discount':
//         return (
//           <span className='badge bg-info'>
//             <i className='fas fa-percentage me-1'></i>
//             {t('خصم')}
//           </span>
//         );
//       default:
//         return (
//           <span className='badge bg-info text-dark'>
//             <i className='fas fa-keyboard me-1'></i>
//             {t('يدوي')}
//           </span>
//         );
//     }
//   };

//   const formatAmount = (amount: number) => {
//     return new Intl.NumberFormat(i18n.language, {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(amount);
//   };

//   const fields = [
//     { name: 'invoiceNum', label: t('InvoiceNumber'), type: 'string' },
//     { name: 'peopleName2', label: t('Supplier'), type: 'string' },
//     {
//       name: 'invoiceType',
//       label: t('InvoiceType'),
//       type: 'options',
//       options: [
//         { value: 'Standard', label: t('Standard') },
//         { value: 'CreditMemo', label: t('CreditMemo') },
//         { value: 'DebitMemo', label: t('DebitMemo') }
//       ]
//     },
//     {
//       name: 'referenceType',
//       label: t('ReferenceType'),
//       type: 'options',
//       options: [
//         { value: 'Bill', label: t('PurchaseOrder') },
//         { value: 'EXP', label: t('Expenses') },
//         { value: 'EXP_FAST', label: t('FastExpenses') },
//         { value: 'DebitMemo', label: t('PurchaseReturn') },
//         { value: 'Discount', label: t('Discount') },
//         { value: 'Manual', label: t('Manual') }
//       ]
//     },
//     {
//       name: 'postedFlag',
//       label: t('PostingStatus'),
//       type: 'boolean',
//       options: [
//         { value: true, label: t('Posted') },
//         { value: false, label: t('NotPosted') }
//       ]
//     }
//   ];

//   const breadcrumbList = [
//     { name: t('Home'), link: ':moduleHome' },
//     { name: t('PaymentInvoices'), link: null }
//   ];

//   const totalInvoices: number = totalItems;
//   const postedInvoices: number = data?.filter((item: any) => item.postedFlag).length || 0;
//   const pendingInvoices: number = data?.filter((item: any) => !item.postedFlag).length || 0;
//   const totalAmount: number = data?.reduce((sum: number, item: any) => sum + (item.invoiceAmount || 0), 0) || 0;

//   // ✅ خيارات الموردين ووحدات التشغيل

//   return (
//     <>
//       <div className='d-flex flex-wrap align-items-center gap-2'>
//         <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('PaymentInvoices')} />

//         <div className='ms-auto'>
//           {HasPermission('APAddApInvoices') && (
//             <Link to='AddApInvoices' className='btn btn-theme'>
//               <i className='fa fa-plus-circle fa-fw me-1'></i>
//               {t('NewInvoice')}
//             </Link>
//           )}
//         </div>
//       </div>

//       {/* بطاقات الإحصائيات */}
//       <div className='row mb-4'>
//         <div className='col-6 col-lg-3'>
//           <Card className='bg-primary bg-opacity-10 border-primary border-0 shadow-sm h-100'>
//             <CardBody className='py-3'>
//               <div className='d-flex align-items-center'>
//                 <div className='flex-shrink-0'>
//                   <i className='fas fa-file-invoice fa-2x text-primary'></i>
//                 </div>
//                 <div className='flex-grow-1 ms-3'>
//                   <h4 className='text-primary mb-0'>{totalInvoices}</h4>
//                   <p className='text-muted mb-0'>{t('TotalInvoices')}</p>
//                 </div>
//               </div>
//             </CardBody>
//           </Card>
//         </div>

//         <div className='col-6 col-lg-3'>
//           <Card className='bg-success bg-opacity-10 border-success border-0 shadow-sm h-100'>
//             <CardBody className='py-3'>
//               <div className='d-flex align-items-center'>
//                 <div className='flex-shrink-0'>
//                   <i className='fas fa-check-circle fa-2x text-success'></i>
//                 </div>
//                 <div className='flex-grow-1 ms-3'>
//                   <h4 className='text-success mb-0'>{postedInvoices}</h4>
//                   <p className='text-muted mb-0'>{t('PostedInvoices')}</p>
//                 </div>
//               </div>
//             </CardBody>
//           </Card>
//         </div>

//         <div className='col-6 col-lg-3'>
//           <Card className='bg-warning bg-opacity-10 border-warning border-0 shadow-sm h-100'>
//             <CardBody className='py-3'>
//               <div className='d-flex align-items-center'>
//                 <div className='flex-shrink-0'>
//                   <i className='fas fa-clock fa-2x text-warning'></i>
//                 </div>
//                 <div className='flex-grow-1 ms-3'>
//                   <h4 className='text-warning mb-0'>{pendingInvoices}</h4>
//                   <p className='text-muted mb-0'>{t('PendingInvoices')}</p>
//                 </div>
//               </div>
//             </CardBody>
//           </Card>
//         </div>

//         <div className='col-6 col-lg-3'>
//           <Card className='bg-info bg-opacity-10 border-info border-0 shadow-sm h-100'>
//             <CardBody className='py-3'>
//               <div className='d-flex align-items-center'>
//                 <div className='flex-shrink-0'>
//                   <i className='fas fa-money-bill-wave fa-2x text-info'></i>
//                 </div>
//                 <div className='flex-grow-1 ms-3'>
//                   <h4 className='text-info mb-0'>{formatAmount(totalAmount)}</h4>
//                   <p className='text-muted mb-0'>{t('TotalAmount')}</p>
//                 </div>
//               </div>
//             </CardBody>
//           </Card>
//         </div>
//       </div>

//       <Card className='mb-4'>
//         <CardHeader>
//           <div className='d-flex flex-wrap align-items-center gap-3 ms-auto'>
//             {/* ✅ فلترة بالمورد */}
//             <div className='filter-group' style={{ minWidth: '200px', maxWidth: '250px' }}>
//               <label className='form-label small text-muted mb-1'>{t('Supplier')}</label>
//               <Select
//                 value={supplierFilter}
//                 onChange={setSupplierFilter}
//                 options={OptionSuppliers}
//                 placeholder={t('SelectSupplier')}
//                 isClearable
//                 isSearchable
//                 className='react-select-container'
//                 classNamePrefix='react-select'
//                 styles={{
//                   control: base => ({
//                     ...base,
//                     minHeight: '38px',
//                     fontSize: '14px'
//                   })
//                 }}
//               />
//             </div>

//             {/* ✅ فلترة بوحدة التشغيل */}
//             <div className='filter-group' style={{ minWidth: '200px', maxWidth: '250px' }}>
//               <label className='form-label small text-muted mb-1'>{t('OperatingUnit')}</label>
//               <Select
//                 value={organizationFilter}
//                 onChange={setOrganizationFilter}
//                 options={OperatingUnitOptions}
//                 placeholder={t('SelectOrganization')}
//                 isClearable
//                 isSearchable
//                 className='react-select-  container'
//                 classNamePrefix='react-select'
//                 styles={{
//                   control: base => ({
//                     ...base,
//                     minHeight: '38px',
//                     fontSize: '14px'
//                   })
//                 }}
//               />
//             </div>

//             {/* ✅ التاريخ من */}
//             <div className='filter-group' style={{ minWidth: '150px' }}>
//               <label className='form-label small text-muted mb-1'>{t('DateFrom')}</label>
//               <div className='input-group'>
//                 <span className='input-group-text'>
//                   <i className='fas fa-calendar-alt text-muted'></i>
//                 </span>
//                 <input
//                   type='date'
//                   className='form-control border-start-0'
//                   value={dateFrom}
//                   onChange={e => setDateFrom(e.target.value)}
//                 />
//               </div>
//             </div>

//             {/* ✅ التاريخ إلى */}
//             <div className='filter-group' style={{ minWidth: '150px' }}>
//               <label className='form-label small text-muted mb-1'>{t('DateTo')}</label>
//               <div className='input-group'>
//                 <span className='input-group-text'>
//                   <i className='fas fa-calendar-alt text-muted'></i>
//                 </span>
//                 <input
//                   type='date'
//                   className='form-control border-start-0'
//                   value={dateTo}
//                   onChange={e => setDateTo(e.target.value)}
//                 />
//               </div>
//             </div>

//             {/* ✅ أزرار التطبيق والمسح */}
//             <div className='d-flex align-items-end gap-2'>
//               <button
//                 className='btn btn-outline-secondary'
//                 type='button'
//                 onClick={clearFilters}
//                 title={t('ClearFilters')}
//                 style={{ height: '38px' }}
//               >
//                 <i className='fas fa-times fa-fw me-1'></i>
//                 {t('Clear')}
//               </button>
//               <button
//                 className='btn btn-theme'
//                 type='button'
//                 onClick={applyFilters}
//                 title={t('ApplyFilters')}
//                 style={{ height: '38px' }}
//               >
//                 <i className='fas fa-filter fa-fw me-1'></i>
//                 {t('Apply')}
//               </button>
//             </div>

//             {/* ✅ زر التصفية المتقدمة */}
//             <button
//               className='btn btn-outline-theme w-md-auto'
//               onClick={() => setShowFilters(true)}
//               title={t('SearchFilters')}
//               style={{ height: '38px' }}
//             >
//               <i className='fas fa-sliders-h fa-fw me-1'></i>
//               {t('MoreFilters')}
//             </button>
//           </div>
//         </CardHeader>

//         <Loading loading={loading} error={error}>
//           <CardBody>
//             <div className='table-responsive'>
//               <table className='table table-hover mb-0'>
//                 <thead className='bg-theme bg-opacity-25 fw-bold'>
//                   <tr>
//                     <th className='small'>{t('InvoiceNumber')}</th>
//                     <th className='small'>{t('InvoiceDate')}</th>
//                     <th className='small'>{t('Supplier')}</th>
//                     <th className='small'>{t('InvoiceType')}</th>
//                     <th className='small'>{t('المصدر')}</th>
//                     <th className='small'>{t('وحدة التشغيـل')}</th>
//                     <th className='small'>{t('Amount')}</th>
//                     <th className='small'>{t('PostingStatus')}</th>
//                     <th className='small text-end'>{t('Actions')}</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {displayData.length > 0 ? (
//                     displayData.map((item: any) => (
//                       <tr key={item.id}>
//                         <td className='align-middle'>
//                           <strong className='text-primary'>{item.invoiceNum}</strong>
//                         </td>
//                         <td className='align-middle'>{item.invoiceDate}</td>
//                         <td className='align-middle'>
//                           <div className='d-flex flex-column'>
//                             <strong className='fw-bold'>
//                               {i18n.language === 'en' ? item.peopleName : item.peopleName2}
//                             </strong>
//                             {item.peopleCode && (
//                               <small className='text-muted'>
//                                 {t('Code')}: {item.peopleCode}
//                               </small>
//                             )}
//                           </div>
//                         </td>
//                         <td className='align-middle'>{getInvoiceTypeBadge(item.invoiceType)}</td>
//                         <td className='align-middle'>{getReferenceTypeBadge(item.referenceType)}</td>
//                         <td className='align-middle'>
//                           {i18n.language === 'en' ? item.organizationName : item.organizationName2}
//                         </td>
//                         <td className='align-middle'>
//                           <span className='fw-bold text-theme'>{formatAmount(item.invoiceAmount)}</span>
//                         </td>
//                         <td className='align-middle text-center'>{getPostedFlagBadge(item.postedFlag || false)}</td>
//                         <td className='align-middle text-end'>
//                           <div className='d-flex justify-content-end gap-2'>
//                             {HasPermission('APViewApInvoicesDetails') && (
//                               <Link
//                                 to={`${item.id}/UpdateApInvoices`}
//                                 className='btn btn-sm btn-outline-theme'
//                                 title={t('ViewDetails')}
//                               >
//                                 <i className='fas fa-eye fa-fw me-1'></i>
//                                 {t('Show')}
//                               </Link>
//                             )}
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={9} className='text-center py-4 text-muted'>
//                         <i className='fa fa-inbox fa-2x mb-2'></i>
//                         <br />
//                         {isUsingFixedFilters ? t('NoSearchResults') : t('NoInvoicesRegistered')}
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </CardBody>
//         </Loading>

//         <CardFooter>
//           <div className='text-theme'>
//             <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
//           </div>
//         </CardFooter>
//       </Card>

//       <DynamicFilter tableKey={TABLE_KEY} fields={fields} show={showFilters} onClose={() => setShowFilters(false)} />

//       <NeatixModal
//         show={showPurchaseRequest}
//         setShow={setShowPurchaseRequest}
//         bodyClassName='p-0'
//         size='lg'
//         showHeader={false}
//       >
//         <PurchaseRequestList Route='ApInvoice' />
//       </NeatixModal>
//     </>
//   );
// };

// export default Index;

import { useEffect, useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardFooter, CardHeader } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import NeatixModal from '@components/Modal/NeatixModal';
import PurchaseRequestList from '../../../PUR/Transactions/PurchaseRequest/PurchaseRequestList';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getPagedData, setEndpoint, setFilters, setSortOrders } from '@store/DynamicSlice/dynamicTableSlice';
import { DynamicFilter } from '@Helper/DynamicFilter/DynamicFilter';
import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import Select from 'react-select';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';

const TABLE_KEY = 'ApInvoices_Index';
// import { Dropdown, ButtonGroup } from 'react-bootstrap';

const Index = () => {
  const [showPurchaseRequest, setShowPurchaseRequest] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  const { OperatingUnitOptions } = useGetOperatingUnitWithPermission();
  const { OptionSuppliers } = useGetSuppliersList();

  // ✅ حالة الفلاتر الجديدة
  const [supplierFilter, setSupplierFilter] = useState<any>(null);
  const [organizationFilter, setOrganizationFilter] = useState<any>(null);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  const [activeFiltersCount, setActiveFiltersCount] = useState(0);

  const { t, i18n } = useTranslation();
  const { HasPermission } = usePermissions();

  const dispatch = useAppDispatch();
  const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);
  const data = tableState?.data ?? [];
  const loading = tableState?.loading ?? false;
  const error = tableState?.error ?? null;
  const filters = tableState?.filters ?? [];

  useEffect(() => {
    dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'Ap/GetApInvoicesList_Paged' }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  }, [dispatch]);

  // ✅ حساب عدد الفلاتر النشطة
  useEffect(() => {
    setActiveFiltersCount(filters.length);
  }, [filters]);

  // ✅ دالة لإنشاء ID فريد للفلتر
  const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  // ✅ دالة تطبيق الفلاتر
  const applyFilters = () => {
    const newFilters: any[] = [];

    // ✅ فلترة حسب المورد
    if (supplierFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'peopleId',
        operator: 0, // OpEquals
        value: supplierFilter.value
      });
    }

    // ✅ فلترة حسب وحدة التشغيل
    if (organizationFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'organizationId',
        operator: 0, // OpEquals
        value: organizationFilter.value
      });
    }

    // ✅ فلترة حسب التاريخ من
    if (dateFrom) {
      newFilters.push({
        id: generateFilterId(),
        field: 'invoiceDate',
        operator: 3, // OpGreaterOrEqual
        value: dateFrom
      });
    }

    // ✅ فلترة حسب التاريخ إلى
    if (dateTo) {
      newFilters.push({
        id: generateFilterId(),
        field: 'invoiceDate',
        operator: 5, // OpLessOrEqual
        value: dateTo
      });
    }

    // ✅ تطبيق الفلاتر عبر setFilters
    dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  // ✅ دالة مسح جميع الفلاتر
  const clearFilters = (): void => {
    setSupplierFilter(null);
    setOrganizationFilter(null);
    setDateFrom('');
    setDateTo('');

    // ✅ مسح جميع الفلاتر من الـ store
    dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  // ✅ دالة مسح فلتر واحد
  const removeFilter = (fieldName: string) => {
    const currentFilters = filters || [];
    const filtered = currentFilters.filter((filter: any) => filter.field !== fieldName);

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: filtered }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));

    // ✅ تحديث الحقول المحلية
    if (fieldName === 'peopleId') {
      setSupplierFilter(null);
    } else if (fieldName === 'organizationId') {
      setOrganizationFilter(null);
    } else if (fieldName === 'invoiceDate') {
      // نبحث عن فلاتر التاريخ ونزيلها جميعاً
      setDateFrom('');
      setDateTo('');
    }
  };

  // ✅ دالة لعرض حالة الدفع
  const getPaymentStatusBadge = (paymentFlag: boolean) => {
    if (paymentFlag) {
      return (
        <span className='badge bg-success'>
          <i className='fas fa-check-circle me-1'></i>
          {t('مدفوعة')}
        </span>
      );
    } else {
      return (
        <span className='badge bg-danger'>
          <i className='fas fa-clock me-1'></i>
          {t('غير مدفوعة')}
        </span>
      );
    }
  };

  const displayData = data;

  const getPostedFlagBadge = (flag: boolean) =>
    flag ? (
      <span className='badge bg-success'>
        <i className='fas fa-check me-1'></i>
        {t('Posted')}
      </span>
    ) : (
      <span className='badge bg-danger'>
        <i className='fas fa-times me-1'></i>
        {t('NotPosted')}
      </span>
    );

  const getInvoiceTypeBadge = (type: string) => {
    switch (type) {
      case 'Standard':
        return (
          <span className='badge bg-primary'>
            <i className='fas fa-file-invoice me-1'></i>
            {t('Standard')}
          </span>
        );
      case 'CreditMemo':
      case 'DebitMemo':
        return (
          <span className='badge bg-warning text-dark'>
            <i className='fas fa-file-invoice-dollar me-1'></i>
            {t('DebitMemo')}
          </span>
        );
      default:
        return (
          <span className='badge bg-secondary'>
            <i className='fas fa-file me-1'></i>
            {type}
          </span>
        );
    }
  };

  // ✅ لاحقة (غير مخزني) حسب اللغة بدون الحاجة لمفاتيح ترجمة جديدة
  const nonInvSuffix = i18n.language === 'ar' ? ' (غير مخزني)' : ' (Non-Inventory)';

  const getReferenceTypeBadge = (refType: string) => {
    switch (refType) {
      case 'Bill':
        return (
          <span className='badge bg-success text-dark'>
            <i className='fas fa-shopping-cart me-1'></i>
            {t('أمر شـــراء')}
          </span>
        );
      case 'Bill_NonInventory':
        return (
          <span className='badge bg-success text-dark'>
            <i className='fas fa-shopping-cart me-1'></i>
            {t('أمر شـــراء')}
            {nonInvSuffix}
          </span>
        );

      case 'EXP':
        return (
          <span className='badge bg-dark'>
            <i className='fas fa-receipt me-1'></i>
            {t('مصروفات')}
          </span>
        );
      case 'EXP_FAST':
        return (
          <span className='badge bg-dark'>
            <i className='fas fa-receipt me-1'></i>
            {t('مصروفات سريــعة')}
          </span>
        );
      case 'DebitMemo':
        return (
          <span className='badge bg-warning text-dark'>
            <i className='fas fa-file-invoice-dollar me-1'></i>
            {t('مردود مشتريات')}
          </span>
        );

      case 'DebitMemo_NonInventory':
        return (
          <span className='badge bg-warning text-dark'>
            <i className='fas fa-file-invoice-dollar me-1'></i>
            {t('مردود مشتريات')}
            {nonInvSuffix}
          </span>
        );

      case 'Discount':
        return (
          <span className='badge bg-info'>
            <i className='fas fa-percentage me-1'></i>
            {t('خصم')}
          </span>
        );
      default:
        return (
          <span className='badge bg-info text-dark'>
            <i className='fas fa-keyboard me-1'></i>
            {t('يدوي')}
          </span>
        );
    }
  };

  const formatAmount = (amount: number) => {
    return new Intl.NumberFormat(i18n.language, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  const fields: any = [
    { name: 'invoiceNum', label: t('رقم فاتورة المورد'), type: 'string' },
    { name: 'Code', label: t('InvoiceNumber'), type: 'string' },
    {
      name: 'invoiceType',
      label: t('InvoiceType'),
      type: 'options',
      options: [
        { value: 'Standard', label: t('Standard') },
        { value: 'CreditMemo', label: t('DebitMemo') }
        // { value: 'DebitMemo', label: t('DebitMemo') }
      ]
    },

    {
      name: 'referenceType',
      label: t('مصدر الفاتورة'),
      type: 'options',
      options: [
        { value: 'Bill', label: t('PurchaseOrder') },
        { value: 'Bill_NonInventory', label: `${t('PurchaseOrder')}${nonInvSuffix}` },
        { value: 'EXP', label: t('Expenses') },
        { value: 'EXP_FAST', label: t('مصروفات سريعة') },
        { value: 'DebitMemo', label: t('PurchaseReturn') },

        { value: 'DebitMemo_NonInventory', label: `${t('PurchaseReturn')}${nonInvSuffix}` },

        { value: 'Discount', label: t('خصم') },
        { value: 'Manual', label: t('يدوي') }
      ]
    },
    {
      name: 'postedFlag',
      label: t('PostingStatus'),
      type: 'options',
      options: [
        { value: true, label: t('Posted') },
        { value: false, label: t('NotPosted') }
      ]
    },
    { name: 'invoiceDate', label: t('InvoiceDate'), type: 'date' },
    { name: 'invoiceAmount', label: t('مبلغ الفاتورة'), type: 'number' },
    { name: 'peopleId', label: t('Supplier'), type: 'options', options: OptionSuppliers },
    { name: 'organizationId', label: t('OperatingUnit'), type: 'options', options: OperatingUnitOptions }
  ];

  const breadcrumbList = [
    { name: t('Home'), link: ':moduleHome' },
    { name: t('PaymentInvoices'), link: null }
  ];

  return (
    <>
      <div className='d-flex flex-wrap align-items-center gap-2'>
        <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('PaymentInvoices')} />

        <div className='ms-auto'>
          <Link to='AddApInvoices' className='btn btn-theme'>
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('NewInvoice')}
          </Link>
        </div>
      </div>

      <Card className='mb-4'>
        <CardHeader>
          <div className='row g-2'>
            {/* ✅ فلترة بوحدة التشغيل */}
            <div className='  col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold  '>
                  <i className='fas fa-building  '></i>
                </span>

                <Select
                  value={organizationFilter}
                  onChange={setOrganizationFilter}
                  options={OperatingUnitOptions}
                  placeholder={t('اختر وحدة تشغيـل')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                  }}
                />
              </div>
            </div>

            {/* ✅ فلترة بالمورد */}
            <div className='  col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold  '>
                  <i className='fas fa-truck '></i>
                </span>

                <Select
                  value={supplierFilter}
                  onChange={setSupplierFilter}
                  options={OptionSuppliers}
                  placeholder={t('اختر مورد')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                  }}
                />
              </div>
            </div>

            {/* ✅ التاريخ من وإلى في input group واحد */}
            <div className='  col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text'>
                  <i className='fas fa-calendar-alt text-muted'></i>
                </span>
                <input
                  type='date'
                  className='form-control border-start-0'
                  value={dateFrom}
                  onChange={e => setDateFrom(e.target.value)}
                  placeholder={t('From')}
                />
                <span className='input-group-text '>-</span>
                <input
                  type='date'
                  className='form-control'
                  value={dateTo}
                  onChange={e => setDateTo(e.target.value)}
                  placeholder={t('To')}
                />
              </div>
            </div>

            {/* ✅ أزرار التطبيق والمسح */}
            <div className=' col-lg-2 text-end'>
              <button
                className='btn btn-outline-secondary me-2 '
                type='button'
                onClick={clearFilters}
                title={t('ClearFilters')}
                disabled={activeFiltersCount === 0}
              >
                <i className='fas fa-times fa-fw  '></i>
              </button>
              <button
                className='btn btn-theme me-2'
                type='button'
                onClick={applyFilters}
                title={t('ApplyFilters')}
                disabled={!supplierFilter && !organizationFilter && !dateFrom && !dateTo}
              >
                <i className='fas fa-filter fa-fw  '></i>
              </button>
              <button
                className='btn btn-outline-theme w-md-auto'
                onClick={() => setShowFilters(true)}
                title={t('SearchFilters')}
              >
                <i className='fas fa-sliders-h fa-fw'></i>
              </button>
            </div>
          </div>
        </CardHeader>

        <Loading loading={loading} error={error}>
          <div className='table-responsive'>
            <table className='table table-hover mb-0'>
              <thead className='bg-theme bg-opacity-25 fw-bold'>
                <tr>
                  <th className='small'>{t('الرقم')}</th>
                  <th className='small'>{t('InvoiceDate')}</th>
                  <th className='small'>{t('رقم فاتورة المورد')}</th>
                  <th className='small'>{t('Supplier')}</th>
                  <th className='small'>{t('وحدة التشغيـل')}</th>
                  <th className='small'>{t('Amount')}</th>
                  <th className='small'>{t('حالة الدفع')}</th>
                  <th className='small text-center'>{t('PostingStatus')}</th>
                  <th className='small'>{t('المصدر')}</th>
                  <th className='small'>{t('InvoiceType')}</th>
                  <th className='small text-center'>{t('Actions')}</th>
                </tr>
              </thead>

              <tbody>
                {displayData.length > 0 ? (
                  displayData.map((item: any) => (
                    // <tr key={item.id}>
                    //   <td className='align-middle'>
                    //     <strong className='text-theme'>{item.invoiceNum}</strong>
                    //   </td>
                    //   <td className='align-middle'>{item.invoiceDate}</td>
                    //   <td className='align-middle'>
                    //     <span className='fw-bold text-theme'>{formatAmount(item.invoiceAmount)}</span>
                    //   </td>
                    //   <td className='align-middle'>
                    //     <div className='d-flex flex-column'>
                    //       <strong className='fw-bold'>
                    //         {i18n.language === 'en' ? item.peopleName : item.peopleName2}
                    //       </strong>
                    //       {item.peopleCode && (
                    //         <small className='text-muted'>
                    //           {t('Code')}: {item.peopleCode}
                    //         </small>
                    //       )}
                    //     </div>
                    //   </td>
                    //   <td className='align-middle'>
                    //     {i18n.language === 'en' ? item.organizationName : item.organizationName2}
                    //   </td>
                    //   <td className='align-middle text-center'>{getPostedFlagBadge(item.postedFlag || false)}</td>
                    //   <td className='align-middle'>{getInvoiceTypeBadge(item.invoiceType)}</td>
                    //   <td className='align-middle'>{getReferenceTypeBadge(item.referenceType)}</td>
                    //   <td className='align-middle'>{getPaymentStatusBadge(item.paymentFlag || false)}</td>{' '}
                    //   {/* ✅ عرض حالة الدفع */}
                    //   <td className='align-middle text-end'>
                    //     <div className='d-flex justify-content-end gap-2'>
                    //       <Link
                    //         to={`${item.id}/UpdateApInvoices`}
                    //         className='btn btn-sm btn-outline-theme'
                    //         title={t('ViewDetails')}
                    //       >
                    //         <i className='bi bi-info-circle fa-lg me-2'></i>

                    //         {t('ViewDetails')}
                    //       </Link>
                    //     </div>
                    //   </td>
                    // </tr>
                    <tr key={item.id}>
                      <td className='align-middle'>
                        <strong className='text-theme'>{item.code}</strong>
                      </td>
                      <td className='align-middle'>{item.invoiceDate}</td>
                      <td className='align-middle text-center'>
                        <strong>{item.invoiceNum || '--'}</strong>
                      </td>


                      <td className='align-middle'>
                        <div className='d-flex flex-column'>
                          <strong className='fw-bold'>
                            {i18n.language === 'en' ? item.peopleName : item.peopleName2}
                          </strong>
                          {item.peopleCode && (
                            <small className='text-muted'>
                              {t('Code')}: {item.peopleCode}
                            </small>
                          )}
                        </div>
                      </td>

                      <td className='align-middle'>
                        {i18n.language === 'en' ? item.organizationName : item.organizationName2}
                      </td>

                      <td className='align-middle'>
                        <span className='fw-bold text-theme'>{formatAmount(item.invoiceAmount)}</span>
                      </td>

                      <td className='align-middle'>{getPaymentStatusBadge(item.paymentFlag || false)}</td>

                      <td className='align-middle text-center'>{getPostedFlagBadge(item.postedFlag || false)}</td>

                      <td className='align-middle'>{getReferenceTypeBadge(item.referenceType)}</td>

                      <td className='align-middle'>{getInvoiceTypeBadge(item.invoiceType)}</td>

                      <td className='align-middle text-end'>
                        <div className='d-flex justify-content-end gap-2'>
                          <Link
                            to={`${item.id}/UpdateApInvoices`}
                            className='btn btn-sm btn-outline-theme'
                            title={t('ViewDetails')}
                          >
                            <i className='bi bi-info-circle fa-lg me-2'></i>
                            {t('Details')}
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={10} className='text-center py-4 text-muted'>
                      <i className='fa fa-inbox fa-2x mb-2'></i>
                      <br />
                      {activeFiltersCount > 0 ? 'لا توجد نتائج مطابقة لبحثك' : 'لا توجد فواتير مسجلة حتى الآن'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Loading>

        <CardFooter>
          <div className='text-theme'>
            <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
          </div>
        </CardFooter>
      </Card>

      <DynamicFilter tableKey={TABLE_KEY} fields={fields} show={showFilters} onClose={() => setShowFilters(false)} />

      <NeatixModal
        show={showPurchaseRequest}
        setShow={setShowPurchaseRequest}
        bodyClassName='p-0'
        size='lg'
        showHeader={false}
      >
        <PurchaseRequestList Route='ApInvoice' />
      </NeatixModal>
    </>
  );
};

export default Index;
